<template>
  <div id="app">
    <Header />
    <router-view />
    <div class="centerd-container" v-if="globalState.isLoading">
      <SyncLoader color="#888"></SyncLoader>
    </div>
    <Footer />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useStore } from "vuex";
import _ from "lodash";

import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import axios from "@/axios/index";
import { globalState } from "@/common/globalState";
</script>

<style>
#app {
  height: 100%;
}

#app_mainDiv {
  height: 100%;
}

.centerd-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.swal2-container {
  z-index: 8000;
}
</style>
